import React from 'react';
import Paginator from './results/paginator';
import OffMarketResultCard from './results/off_market_result_card';

import { connect } from 'react-redux';
import { EmptyState } from './results/empty_state';
import EmptyStateBadges from './results/empty_state_badges';
import type { RootState } from '../../store/root_reducer';

type OffMarketResultsCardListProps = {
  allResults: RootState['results']['offMarketResults'];
  containerRef: React.RefObject<HTMLDivElement>;
  loading: boolean;
  selectAll: boolean;
  selectedPropertyIds: Set<string>;
  onSelectToggle: (propertyId: string) => void;
}

function OffMarketResultsCardList(
  {
    allResults,
    containerRef,
    loading,
    selectAll,
    selectedPropertyIds,
    onSelectToggle
  }: OffMarketResultsCardListProps) {
  if (!allResults) {
    return null;
  }

  return (
    <div className="h-100 overflow-auto position-relative z-2" ref={containerRef}>
      {allResults.length > 0 && (
        <>
          <div className={`mt-1 p-3 transition-opacity ${loading ? 'opacity-75' : 'opacity-100'}`}>
            {allResults.map(result => (
              <OffMarketResultCard
                isSelected={selectAll || selectedPropertyIds.has(result.propertyId)}
                key={result.propertyId}
                result={result}
                onSelectToggle={onSelectToggle}
              />
            ))}
          </div>

          <div className="d-flex justify-content-center mb-4">
            <Paginator containerRef={containerRef} />
          </div>
        </>
      )}
      {allResults.length === 0 && (
        <div>
          <EmptyState subtitle="Expand your search to find matching, off market properties" title="No matches" />
          <EmptyStateBadges />
        </div>
      )}
    </div>
  );
}

const mapStateToProps = ({
  results: {
    offMarketResults
  },
  ui: { loading }
}) => {
  return {
    allResults: offMarketResults,
    loading
  };
};
export default connect(mapStateToProps)(OffMarketResultsCardList);

